import React from 'react';
import { Link } from 'react-router-dom';
import './css/Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img
                src="https://res.cloudinary.com/drj2hrug3/image/upload/v1761774280/Picsart_25-10-29_22-42-31-059_kuvztc.png"
                alt="Reyza"
                loading="lazy"
                decoding="async"
              />
              <span className="footer-brand-name">Reyza</span>
            </Link>
            <p className="footer-tagline">
              Des achats malins, rapides et securises dans toutes vos categories preferees.
            </p>
            <div className="footer-cta">
              <span>Besoin d'aide pour choisir ?</span>
              <Link to="/shop-ai" className="footer-ai-link">
                Acheter avec l'IA
              </Link>
            </div>
          </div>

          <div className="footer-col">
            <h4>Explorer</h4>
            <Link to="/">Accueil</Link>
            <Link to="/categories">Categories</Link>
            <Link to="/shop-ai">Acheter avec l'IA</Link>
            <Link to="/search">Recherche</Link>
          </div>

          <div className="footer-col">
            <h4>Assistance</h4>
            <Link to="/order-tracking">Suivre une commande</Link>
            <Link to="/chat">Chat en direct</Link>
            <Link to="/checkout">Paiement</Link>
          </div>

          <div className="footer-col">
            <h4>Compte</h4>
            <Link to="/login">Connexion</Link>
            <Link to="/register">Creer un compte</Link>
            <Link to="/profile">Profil</Link>
          </div>
        </div>

        <div className="footer-divider" />

        <div className="footer-bottom">
          <span>Reyza (c) {year}. Tous droits reserves.</span>
          <div className="footer-bottom-links">
            <Link to="/order-tracking">Livraison</Link>
            <Link to="/chat">Assistance</Link>
            <Link to="/shop-ai">Acheter avec l'IA</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
